export default function WhatYouGet() {
  const deliverables = [
    {
      icon: 'ri-settings-2-line',
      title: 'Une usine complète, pas juste un site',
      description: 'Un écosystème digital complet avec tous les outils connectés pour générer et gérer vos leads automatiquement.'
    },
    {
      icon: 'ri-lightbulb-line',
      title: 'Stratégie + Exécution + Outils',
      description: 'Nous ne nous contentons pas de conseils : nous mettons en place et optimisons tout pour vous.'
    },
    {
      icon: 'ri-calendar-check-line',
      title: 'Des rendez-vous qualifiés',
      description: 'Pas de simples contacts, mais des prospects chauds prêts à échanger avec vous sur votre offre.'
    },
    {
      icon: 'ri-dashboard-line',
      title: 'Pilotage par les chiffres',
      description: 'Tableaux de bord en temps réel pour suivre vos performances et prendre les bonnes décisions.'
    },
    {
      icon: 'ri-arrow-up-line',
      title: 'Un système évolutif',
      description: 'Une infrastructure qui grandit avec vous et s\'adapte à vos nouveaux objectifs.'
    },
    {
      icon: 'ri-shield-check-line',
      title: 'Support & Formation',
      description: 'Accompagnement continu et formation de vos équipes pour une autonomie progressive.'
    }
  ];

  return (
    <section className="py-16 sm:py-24 bg-white overflow-hidden">
      <div className="w-full max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        {/* Header */}
        <div className="text-center mb-12 sm:mb-20">
          <h2 className="text-3xl sm:text-4xl md:text-5xl font-bold text-gray-900 mb-4 sm:mb-6">
            Ce que vous obtenez concrètement
          </h2>
          <p className="text-lg sm:text-xl text-gray-600 max-w-3xl mx-auto leading-relaxed">
            6 raisons de transformer votre présence digitale en machine à leads
          </p>
        </div>

        {/* Main Deliverables Grid */}
        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-5 sm:gap-6 mb-12 sm:mb-16">
          {deliverables.map((item, index) => (
            <div
              key={index}
              className="bg-gradient-to-br from-white to-orange-50 rounded-2xl p-6 sm:p-8 border border-orange-100 hover:border-orange-300 hover:shadow-xl transition-all duration-300 group"
            >
              <div className="w-12 h-12 sm:w-14 sm:h-14 rounded-xl bg-gradient-to-br from-orange-500 to-orange-600 flex items-center justify-center mb-4 sm:mb-5 group-hover:scale-110 transition-transform duration-300">
                <i className={`${item.icon} text-xl sm:text-2xl text-white`}></i>
              </div>
              <h3 className="text-lg sm:text-xl font-bold text-gray-900 mb-3 break-words">
                {item.title}
              </h3>
              <p className="text-gray-600 leading-relaxed text-sm break-words">
                {item.description}
              </p>
            </div>
          ))}
        </div>

      </div>
    </section>
  );
}
